import request from '@/config/axios'

export interface RoomVO {
  id: string | number
  shopId: string | number
  spuId: string | number
  roomNo: string
  floor?: string
  roomState: number // 0空闲/1预订/2入住/3退房/4清洁/5维修/6锁定
  remark?: string
  createTime?: string
}

// 房间分页查询
export const getRoomPage = (params: any) => {
  return request.get({ url: '/hotel/room/page', params })
}

// 获取房间详情
export const getRoom = (id: string) => {
  return request.get({ url: '/hotel/room/get?id=' + id })
}

// 新增房间
export const createRoom = (data: RoomVO) => {
  return request.post({ url: '/hotel/room/create', data })
}

// 修改房间
export const updateRoom = (data: RoomVO) => {
  return request.put({ url: '/hotel/room/update', data })
}

// 删除房间
export const deleteRoom = (id: string | number) => {
  return request.delete({ url: '/hotel/room/delete?id=' + id })
}

// 批量创建房间
export const batchCreate = (data: RoomVO[]) => {
  return request.post({ url: '/hotel/room/batch-create', data })
}

// 获取全部房间（下拉选项用）
export const listAllRooms = () => {
  return request.get({ url: '/hotel/room/page', params: { pageNo: 1, pageSize: 200 } })
}
